import React from 'react';
import dictData from 'dictionary';

const ApiLoaderFallback: React.FC = () => {
  return (
    <div className="content-wrapper text-center my-auto">
      <p className="api-loader-error">
        <strong>
          {dictData.errApiLoader['loader-error-000']}
          <br />
          {dictData.errApiLoader['loader-error-001']}
        </strong>
      </p>
    </div>
  );
};

export default ApiLoaderFallback;
